export default {
  PRODUCT_CENTER: 'https://test.project.hrtps.com',
  baseURL: '/gateway',
  COS: {
    bucket: 'chatbot-test-1256119856',
    region: 'ap-shanghai'
  }
};
